export const ACTION_APP_LOAD_STATUS_CHANGED = 'ACTION_APP_LOAD_STATUS_CHANGED';
export const ACTION_APP_ERROR = 'ACTION_APP_ERROR';